module.exports = __webpack_public_path__ + "img/BAU Seniors_Infographics_38.25b0df66.png";